<div class="cadastro-parceiros-container cadastro-parceiros-inscricao">
  <div class="inscription-main-flow" *ngIf="!showSuccessScreen">
    <div class="form-section">
      <div class="inscription-form-flow">
        <umkt-cadastro-parceiros-cnpj *ngIf="wizardStep === -1" (validaded)="ValidationCnpjfinished($event)">
        </umkt-cadastro-parceiros-cnpj>
        <div class="inscription-header-gap-wrap" *ngIf="wizardStep >= 0">
          <div class="inscription-header-gap" aria-hidden="true"></div>
          <header class="inscription-page-header">
            <div class="inscription-stepper-wrap">
              <umkt-partner-inscription-stepper
                [standalone]="true"
                [steps]="inscriptionSteps"
                [currentStepIndex]="stepperIndex"
                [labelTotalSteps]="stepFractionTotal"
                [labelCurrentStep]="stepperLabelCurrent"
                [labelPrefix]="'pages.partnerRegistration.inscription.stepper.labelPrefix' | i18n"
                [showCurrentStepLabel]="false"
                [useStatusIcons]="true"
              ></umkt-partner-inscription-stepper>
            </div>
            <hr class="inscription-page-header-divider" />
          </header>
        </div>

        <umkt-card-wrapper
          *ngIf="wizardStep >= 0 && wizardStep <= 1"
          class="company-registration-card"
          [title]="''"
          [hideHeader]="true"
          [variant]="'default'"
        >
          <div class="company-card-top">
            <div class="company-card-header">
              <div class="company-card-icon" aria-hidden="true">
                <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g filter="url(#companyIconFilter)">
                    <path
                      d="M3 16C3 8.26801 9.26801 2 17 2H37C44.732 2 51 8.26801 51 16V36C51 43.732 44.732 50 37 50H17C9.26801 50 3 43.732 3 36V16Z"
                      fill="#FEF2F2"
                      shape-rendering="crispEdges"
                    />
                    <path
                      d="M21 36V18C21 17.4696 21.2107 16.9609 21.5858 16.5858C21.9609 16.2107 22.4696 16 23 16H31C31.5304 16 32.0391 16.2107 32.4142 16.5858C32.7893 16.9609 33 17.4696 33 18V36H21Z"
                      stroke="#DA291C"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M21 26H19C18.4696 26 17.9609 26.2107 17.5858 26.5858C17.2107 26.9609 17 27.4696 17 28V34C17 34.5304 17.2107 35.0391 17.5858 35.4142C17.9609 35.7893 18.4696 36 19 36H21"
                      stroke="#DA291C"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M33 23H35C35.5304 23 36.0391 23.2107 36.4142 23.5858C36.7893 23.9609 37 24.4696 37 25V34C37 34.5304 36.7893 35.0391 36.4142 35.4142C36.0391 35.7893 35.5304 36 35 36H33"
                      stroke="#DA291C"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M25 20H29"
                      stroke="#DA291C"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M25 24H29"
                      stroke="#DA291C"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M25 28H29"
                      stroke="#DA291C"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M25 32H29"
                      stroke="#DA291C"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <filter
                      id="companyIconFilter"
                      x="0"
                      y="0"
                      width="54"
                      height="54"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect1_dropShadow" />
                      <feOffset dy="1" />
                      <feGaussianBlur stdDeviation="1" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="1" />
                      <feGaussianBlur stdDeviation="1.5" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                      <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
                    </filter>
                  </defs>
                </svg>
              </div>
              <div class="company-card-text">
                <h3 class="company-card-title">{{ currentCardTitle }}</h3>
                <p class="company-card-description">{{ currentCardDescription }}</p>
              </div>
            </div>
          </div>
          <div class="company-card-bottom">
            <!-- Step 1: Dados da Empresa -->
            <umkt-inscription-step1
              *ngIf="wizardStep === 0"
              [partnerForm]="partnerForm"
              [isLoadingCNPJ]="isLoadingCNPJ"
              [onCnpjSearchClick]="onCnpjSearchClick.bind(this)"
            >
            </umkt-inscription-step1>

            <!-- Step 2: Endereço -->
            <umkt-inscription-step2
              *ngIf="wizardStep === 1"
              [partnerForm]="partnerForm"
              [brazilStates]="brazilStates"
              [onCepSearchClick]="onCepSearchClick.bind(this)"
            >
            </umkt-inscription-step2>

            <div class="wizard-actions">
              <button
                type="button"
                class="wizard-btn wizard-btn--ghost"
                (click)="wizardStep === 0 ? onCancelInscription() : onWizardBack()"
              >
                {{ (wizardStep === 0 ? 'pages.partnerRegistration.inscription.buttons.cancel' : 'pages.partnerRegistration.inscription.buttons.back') | i18n }}
              </button>
              <button
                type="button"
                class="wizard-btn wizard-btn--primary"
                (click)="onWizardContinue()"
                [disabled]="!isCurrentStepValid || isSubmitting"
              >
                {{ 'pages.partnerRegistration.inscription.buttons.continue' | i18n }}
              </button>
            </div>
          </div>
        </umkt-card-wrapper>

        <!-- Step 3: Questionário sobre a startup -->
        <umkt-inscription-step3
          *ngIf="wizardStep === 2"
          class="inscription-step3-host"
          [partnerForm]="partnerForm"
          [isSubmitting]="isSubmitting"
          (backStep)="onWizardBack()"
          (submitStep)="onStep3Submit()"
        ></umkt-inscription-step3>
      </div>
    </div>

    <section
      class="partner-area-cta partner-inscription-form-footer-cta"
      aria-labelledby="partner-inscription-form-footer-title"
    >
      <div class="partner-area-cta__content">
        <div class="partner-area-cta__text-group">
          <h2 id="partner-inscription-form-footer-title" class="partner-area-cta__title">
            {{ 'pages.partnerRegistration.inscription.footerCta.title' | i18n }}
          </h2>
          <p class="partner-area-cta__description">
            {{ 'pages.partnerRegistration.inscription.footerCta.description' | i18n }}
          </p>
        </div>
        <button type="button" class="partner-area-cta__button" (click)="goToPartnerPortal()">
          {{ 'pages.partnerRegistration.inscription.footerCta.button' | i18n }}
        </button>
      </div>
    </section>
  </div>

  <umkt-partner-inscription-success-cta
    [showSuccess]="showSuccessScreen"
    (partnerPortalClick)="goToPartnerPortal()"
  ></umkt-partner-inscription-success-cta>
</div>
